import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import defaultImg from '../../../images/payment/logo.png';

import styles from './PaymentMethods.css';


const ContentWithTooltip = (props) => {
  const {
    handleSelection,
    isSelected,
    method,
    toolTipVisible,
  } = props;

  const {
    label,
    processorId,
    value,
  } = method || {};

  const imageUrl = useMemo(() => {
    let imgSrc = '';
    try {
      imgSrc = require(`images/payment/${processorId}_${value}.jpg`);
    } catch (err) {
      imgSrc = defaultImg;
    }

    return imgSrc;
  }, [processorId, value]);

  const onClickMethod = useCallback(() => {
    handleSelection(method);
  }, [handleSelection, method]);

  const renderTooltip = useMemo(() => {
    if (!toolTipVisible) {
      return null;
    }

    return (
      <div className={styles.tooltip}>
        {label}
      </div>
    );
  }, [label, toolTipVisible]);

  return (
    <div
      className={`${styles.method} ${isSelected ? styles.selected : ''}`}
      id={`method_${value}`}
      onClick={onClickMethod}
    >
      <div className={styles.content}>
        <img alt="" src={imageUrl} />
        <span className={styles.text}>
          {label}
        </span>
      </div>
      {renderTooltip}
    </div>
  );
};

ContentWithTooltip.propTypes = {
  handleSelection: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  method: PropTypes.object.isRequired,
  toolTipVisible: PropTypes.bool.isRequired,
};

export default ContentWithTooltip;
